import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Loader from "@loader";

const PrivacyPolicy = (props) => {
  const { eventSettingsData } = props;

  return (
    <div className="content-body">
      {eventSettingsData?.data ? (
        <div
          className="custom-text-primary-md-normal break-words"
          dangerouslySetInnerHTML={{
            __html: eventSettingsData?.data?.privacy,
          }}
        ></div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return { session: state.session, eventSettingsData: state.eventSettingsData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);
